import Callout from '../Callout';
import Footer from '../Footer';
import IntroText from '../IntroText';
import Media from '../Media';
import MediaSplit from '../MediaSplit';
import ProjectIntro from '../ProjectIntro';

const components = {
  Callout,
  Footer,
  IntroText,
  Media,
  MediaSplit,
  ProjectIntro,

};

export default components;


// WEBPACK FOOTER //
// ./src/components/library/index.js